import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { myWhiteLabelProjectSingleOptionFormatter } from 'components/forms/autocomplete/MyWhiteLabelProject';

import FormAutocomplete from 'components/forms/FormAutocomplete';

import List from 'components/List';
import DataId from 'components/DataId';

class FormWhiteLabelProject extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      onceShown: false,
    };
  }

  componentDidUpdate = prevProps => {
    const { myWhiteLabelProject } = this.props;
    const { onceShown } = this.state;

    if (
      !onceShown &&
      prevProps.myWhiteLabelProject.pending &&
      !myWhiteLabelProject.pending &&
      myWhiteLabelProject.data.count > 1
    ) {
      this.setState({ onceShown: true });
    }
  };

  render() {
    const {
      intl: { messages },
      label,
      selectedWhiteLabelProject,
      selectedProjectData,
      myWhiteLabelProject,
      meta,
      validation,
    } = this.props;
    const { onceShown } = this.state;

    const autocompleteClassName = onceShown ? '' : 'hidden';

    return (
      <>
        <List noRender listName="myWhiteLabelProject" url="/api/whitelabels/my.json" list={myWhiteLabelProject} />

        {selectedWhiteLabelProject && (
          <DataId
            dataIdName="whiteLabelProject"
            dataIdId={selectedWhiteLabelProject}
            url={`/api/whitelabels/${selectedWhiteLabelProject}.json`}
          />
        )}

        {(!selectedProjectData || (selectedProjectData && !selectedProjectData.pending)) && (
          <FormAutocomplete
            {...this.props}
            name="whiteLabelProject"
            label={label || messages.white_label}
            value={myWhiteLabelProjectSingleOptionFormatter(
              (selectedWhiteLabelProject && !selectedProjectData.pending && selectedProjectData.data) || null
            )}
            className={autocompleteClassName}
            returnValueObject
            autocompleteType="myWhiteLabelProject"
            meta={meta}
            validation={validation}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    myWhiteLabelProject: state.list.myWhiteLabelProject,
    selectedProjectData:
      ownProps.selectedWhiteLabelProject && state.dataId.whiteLabelProject[ownProps.selectedWhiteLabelProject]
        ? state.dataId.whiteLabelProject[ownProps.selectedWhiteLabelProject]
        : { pending: true, data: null },
  };
};

export default injectIntl(connect(mapStateToProps)(FormWhiteLabelProject));
